const banks = {
  1: {
    name:                 'bancodobrasil',
    accountLabel:         'Conta Corrente (com dígito de verificação)',
    mask:                 [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    placeholder:          '______-_',
    numericAccountLength: 9,
    maskedMaxLength:      10,
  },
  237: {
    name:                 'bradesco',
    accountLabel:         'Número da conta',
    mask:                 [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    placeholder:          '_______-_',
    numericAccountLength: 8,
    maskedMaxLength:      9,
  },
  104: {
    name:                     'caixa',
    accountLabel:             'Número da conta',
    mask:                     [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    maskLong:                 [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    placeholder:              '________-_',
    placeholderLong:          '____________-_',
    numericAccountLength:     9,
    numericAccountLengthLong: 13,
    maskedMaxLength:          10,
    maskedMaxLengthLong:      14,
  },
  341: {
    name:                 'itau',
    accountLabel:         'Conta Corrente (com dígito de verificação)',
    mask:                 [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
    placeholder:          '_____-_',
    numericAccountLength: 6,
    maskedMaxLength:      7,
  },
  33: {
    name:         'santander',
    accountLabel: 'Conta Corrente (com dígito de verificação)',
    mask:         (rawValue) => {
      if (rawValue.replace(/\D/g, '').length > 8) {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
      }

      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    },
    placeholder:          '________-_',
    numericAccountLength: [8, 9],
    maskedMaxLength:      10,
  },
};
export default banks;
